import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  useToast,
  Select,
  Text,
} from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useStores } from '../../store/store_context';
import UsersSearch from '../users_autocomplete';
import { useState } from 'react';
import PanelsSearch from '../panels_autocomplete';
import GroupsSearch from '../groups_autocomplete';

// Валидационная схема для Formik и Yup
const validationSchema = Yup.object().shape({});

// Компонент формы для просмотра и изменения данных пользователя
const GroupsForm = ({
  onSubmit,
  updatePanelsTable,
  panels,
  groups,
  isDelete = false,
  defaultValue = '',
  defaultGroupId = null,
}) => {
  const { pageStore } = useStores();

  const [panelId, setPanelId] = useState(null);
  const [groupId, setGroupId] = useState(defaultGroupId);

  const toast = useToast();

  const handleSubmit = async (values, actions) => {
    if (!panelId || !groupId) {
      toast({
        title: 'Выберите панель и группу.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      actions.setSubmitting(false);
      return;
    }

    try {
      await onSubmit(panelId, groupId, pageStore.token);
      toast({
        title: isDelete
          ? 'Панель удалена из группы.'
          : 'Панель добавлена в группу.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
      toast({
        title: 'Ошибка',
        description: 'Что-то пошло не так. Пожалуйста, попробуйте снова.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      await updatePanelsTable();
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{}}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <Form>
          <Text>Начните вводить адрес или номер панели</Text>
          <PanelsSearch
            setResult={setPanelId}
            items={(panels || []).map(elem => {
              return {
                id: elem.panel_id,
                name: elem.adress,
                number: elem.fabric_number,
              };
            })}
          />
          <Text>Начните вводить название группы</Text>
          <GroupsSearch
            setResult={setGroupId}
            items={(groups || []).map(elem => {
              return {
                id: elem.group_id,
                name: elem.group_name,
              };
            })}
            defaultValue={defaultValue}
          />

          <Button
            mt={4}
            colorScheme="blue"
            type="submit"
            backgroundColor={'#7B79FF'}
            _hover={{ backgroundColor: '#4945FF' }}
            color="white"
          >
            Сохранить
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default GroupsForm;
